exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slot[data-v-080c5e99]{float:left;width:100%}.slot__window[data-v-080c5e99]{background-color:#fff;width:100%;height:180px;overflow:hidden}.slot__text[data-v-080c5e99]{font-size:32px;color:#343a40}.slot__item[data-v-080c5e99]{margin-top:0;height:180px;width:100%;padding:0 10px;text-align:center;background-color:#fff;color:#000;line-height:160px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-080c5e99","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-teetotums.vue
// module id = 76
// module chunks = 0